import { render, staticRenderFns } from "./hubspot-ticket-composer.vue?vue&type=template&id=448f5a4a"
import script from "./hubspot-ticket-composer.vue?vue&type=script&lang=js"
export * from "./hubspot-ticket-composer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports